import { Badge, Text } from "@mantine/core";
import {
  MantineReactTable,
  useMantineReactTable,
  // createRow,
  type MRT_ColumnDef,
} from "mantine-react-table";
import { useMemo } from "react";

import {
  SpecificationsGet200ResponseRowsInner,
  SpecificationsGet200ResponseRowsInnerCriteriaInner,
} from "@sizlcorp/sizl-api-document/dist/models";

interface InspectCriterialTableProps {
  data?: SpecificationsGet200ResponseRowsInner[];
}

export const InspectCriterialTable = (params: InspectCriterialTableProps) => {
  const { data } = params;

  const columns = useMemo<
    MRT_ColumnDef<SpecificationsGet200ResponseRowsInnerCriteriaInner>[]
  >(
    () => [
      {
        accessorKey: "seq",
        header: "포인트",
        size: 80,
        Cell: (rows) => {
          return <Text ta={"left"}>{rows.row.index + 1}</Text>;
        },
      },
      {
        accessorKey: "name",
        header: "포인트명",
        mantineEditTextInputProps: {
          type: "string",
          required: true,
        },
        Cell: (rows) => {
          return <Text ta={"left"}>{rows.row._valuesCache.name}</Text>;
        },
      },
      {
        accessorKey: "type",
        header: "검사타입",
        mantineEditTextInputProps: {
          type: "string",
          required: true,
        },
        Cell: (rows) => {
          return (
            <Text ta={"left"}>
              {rows.row._valuesCache.type === "boolean" ? (
                <Badge size={"9px"} fw={700} radius={2}>
                  {"체크"}
                </Badge>
              ) : (
                ""
              )}
            </Text>
          );
        },
      },
      {
        accessorKey: "standard",
        header: "기준값",
        size: 120,
        mantineEditTextInputProps: {
          type: "number",
          required: true,
        },
        Cell: (rows) => {
          return (
            <Text ta={"left"}>
              {rows.row._valuesCache.standard && "체크시 합격"}
            </Text>
          );
        },
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    //일단 한 품목에 검사표준은 한개로 가정
    data:
      data?.[0]?.criteria ??
      ([] as SpecificationsGet200ResponseRowsInnerCriteriaInner[]),
    editDisplayMode: "modal", //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: false,
    enableToolbarInternalActions: false, // 우측상단 아이콘 안보이게
    enablePagination: false,
  });

  return <MantineReactTable table={table} />;
};
